import React, { useState } from "react";
import "../../css/pages/services.css";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import imageOne from "../../assets/images/Pensions2.jpg";
import imageTwo from "../../assets/images/Pensions3.jpg";
import imageThree from "../../assets/images/Pensions4.jpg";
import imageFour from "../../assets/images/Pensions5.jpg";
import Hero from "../designSystem/Hero";
import HeroImage from "../../assets/images/Pensions1.jpg";
import ContactUsPage from "./ContactUsPage";

const pensionsData = [
  {
    title: "Pensions",
    subtitle: "Planning for Retirement",
    description:
      "A well-structured pension is key to achieving the retirement you want. We help you understand how much you need to save, how your pension works, and the steps required to build a reliable income for later life, giving you confidence in your financial future.",
    image: imageOne,
  },
  {
    title: "Pensions",
    subtitle: "Pension Advice",
    description:
      "Pensions can be complex, with changing rules, tax considerations and a wide range of options available. We provide clear, straightforward advice to help you make informed decisions, ensuring your pension strategy aligns with your goals and adapts as your circumstances change.",
    image: imageTwo,
  },
  {
    title: "Pensions",
    subtitle: "Pension Consolidation",
    description:
      "Many people build up multiple pension pots throughout their working life, which can be difficult to manage. We help you bring your pensions together where appropriate, making it easier to track performance, reduce unnecessary costs and take control of your retirement planning.",
    image: imageThree,
  },
  {
    title: "Pensions",
    subtitle: "Retirement Income",
    description:
      "Turning your pension savings into a sustainable income requires careful planning. We guide you through your options, helping you balance flexibility, tax efficiency and long-term security so you can enjoy your retirement with peace of mind.",
    image: imageFour,
  },
];

const PensionsPage = () => {
  // State to track which descriptions are shown
  const [showDescriptions, setShowDescriptions] = useState(
    pensionsData.map(() => true),
  );

  // Handler to toggle description visibility for a card
  const handleSeeMoreClick = (idx) => {
    setShowDescriptions((prev) =>
      prev.map((shown, i) => (i === idx ? !shown : shown)),
    );
  };

  return (
    <div className="home-page about-page">
      <Hero
        title="Pension advice you can depend on"
        subtitle="Pensions"
        primary={true}
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
      />

      <section className="page-section">
        <div className="page-section-inner">
          <div className="page-card-grid">
            {pensionsData.map((pension, index) => (
              <div className="page-card" key={index}>
                <div className="page-card-image">
                  <img src={pension.image} alt={pension.title} />
                </div>

                <div className="page-card-content">
                  <div className="nav primary">{pension.title}</div>
                  <h2 className="primary">
                    {pension.subtitle.split(" ")[0]}{" "}
                    <span className="italic-text">
                      {pension.subtitle.split(" ")[1]}{" "}
                      {pension.subtitle.split(" ")[2]}
                    </span>
                  </h2>
                  {showDescriptions[index] && (
                    <div className="content primary">{pension.description}</div>
                  )}

                  <SeeMoreButton onClick={() => handleSeeMoreClick(index)}>
                    {showDescriptions[index] ? "See Less" : "See More"}
                  </SeeMoreButton>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="investment-note-section">
        <div className="home-container investment-note body">
          <strong>Please Note:</strong> The value of pensions and the income
          they produce can fall as well as rise. You may get back less than you
          invested. Transferring out of a final salary pension is unlikely to be
          in the best interests of most people.
        </div>
      </section>
      <ContactUsPage />
    </div>
  );
};

export default PensionsPage;
